module.exports = __webpack_public_path__ + "static/media/empty-worksheet.769b739f.svg";